/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_MoreInputs */

const he_common_more = /** @type {(inputs: Common_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עוד`)
};

const en_common_more = /** @type {(inputs: Common_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

/**
* | output |
* | --- |
* | "More" |
*
* @param {Common_MoreInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const common_more = /** @type {((inputs?: Common_MoreInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_MoreInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_more(inputs)
	return en_common_more(inputs)
});